const redirectURL = `${import.meta.env.REACT_APP_PORTAL_REDIRECT_URL}`;
const fallbackRedirectURL = `${import.meta.env.REACT_APP_PORTAL_FALLBACK_REDIRECT_URL}`;

const LOGIN_HINT_PARAM = 'login_hint';

export const redirectToSignInPage = (returnPath: string) => {
  const currentParams = new URLSearchParams(window.location.search);
  const useFallback = ['1', 'true'].includes(currentParams.get('use_fallback_redirect') ?? '');

  const url = new URL(useFallback ? fallbackRedirectURL : redirectURL);
  url.searchParams.set('path', returnPath);

  const loginHint = currentParams.get(LOGIN_HINT_PARAM);
  if (loginHint) {
    url.searchParams.set(LOGIN_HINT_PARAM, loginHint);
  }

  window.location.href = url.toString();
};
